module.exports = __webpack_public_path__ + "img/11cb6a6.svg";